import { Component, type ErrorInfo, type PropsWithChildren } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    window.electronAPI?.reportError?.({
      message: `${error.name}: ${error.message}`,
      stack: error.stack,
      componentStack: info.componentStack ?? undefined,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6">
          <h2 className="text-lg font-semibold">Something went wrong</h2>
          <pre className="text-xs text-red-700 mt-2">
            {this.state.error.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
